module.exports = __webpack_public_path__ + "static/media/enclosure-loop.ffa8eb86.ogv";